
export const masterdata_list = "/masterdata/list-all";
export const masterdata_create = "/masterdata/create";
export const masterdata_update = "/masterdata/update?id=";


export const send_otp = "/user/send-otp";
export const verify_otp = "/user/verify-otp";
export const logout = "/user/logout"
export const email_login = "/admin/login"


// dashboard
export const dashboard ="/dashboard/admin"

// StudentsComponent
export const students_list_pannding = "/admin/user-subscriptions?isApproved=false&paymentType=PLATFORM_ONLY";
export const students_list_autoapproved = "/admin/user-subscriptions?paymentType=FULL";
export const students_list_approved = "/admin/user-subscriptions?isApproved=true&paymentType=PLATFORM_ONLY";

export const students_profile = "/user/profile/";
export const subscriptions_details = "/user/my-subscriptions?userId=";
export const update_profile = "/user/update"
export const user_exams_add='/user'

// message3
export const messages_get = "/messages/inbox?sender_id="
export const messages_create = "/messages"
export const messages_delete = "/chat/delete"
export const messages_delete_multiple = "/message/delete-multiple"
export const messages_unpin = "/user/unpin"
export const messages_pin = "/user/pin"


//upload
export const batch_create = "/batch/create"
export const institution_dashboard = "/admin/institution-dashboard/"
export const admindetails ="/user/getall?roleType=superadmin"

// notification
export const notification_list ="/notification/list-specific"

// batch
export const batch_get_all ="/batch/get-all?Institution_id="

// version control (Android)
export const version_control_get = `/version-control?platform=android&appVersion=1`;
export const version_control_create = `/version-control/create`;




